import axios, {AxiosInstance} from "axios";
 
export const makeRequest: AxiosInstance = axios.create({
    baseURL: 'http://192.168.0.172:3333/',
    withCredentials: true
})

